import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/machinery/crane")({
  component: () => null,
  beforeLoad: () => {
    throw redirect({
      to: "/machinery/inspection",
      search: { type: "crane" },
      replace: true,
    });
  },
});
